import {
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import logo from "../../assets/logo.png";
import { Call } from "@mui/icons-material";

export const SigmadosDEMO = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [userFirstName, setUserFirstName] = useState("");
  const [country, setCountry] = useState("es");
  const [typeOfCall, setTypeOfCall] = useState("normal");

  const handleSubmit = async (event) => {
    event.preventDefault();

    const fromNumber = "447414695890";
    const agentID = "agent_5f94997ac508a48910a321b558";
    const aiAgentName = "Liliana";
    const baseUrl =
      "https://initiateretellcall-655075094783.us-central1.run.app";

    const url = `${baseUrl}?ai_agent_name=${aiAgentName}&to_number=${phoneNumber}&from_number=${fromNumber}&agent_id=${agentID}`;

    console.log(`Starting call with URL ${url}`);

    await axios
      .request(url, {
        method: "GET",
        headers: {
          "ngrok-skip-browser-warning": "69420",
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => console.log(res));
  };

  return (
    <div className="full-page-background">
      <Grid item xs={12} md={7}>
        <Container className="App" maxWidth="sm">
          <img src={logo} className="App-logo" alt="logo" />
          <h1>SIGMADOS DEMO Español</h1>
          <h3>DEMO creada por JasperVOCAL para CASTILLA – LA MANCHA.</h3>
          <form onSubmit={handleSubmit}>
            <>
              <Select
                value={typeOfCall}
                onChange={(e) => {
                  setTypeOfCall(e.target.value);
                }}
                required
                sx={{
                  backgroundColor: "white",
                  borderRadius: "4px",
                }}
              >
                <MenuItem value="normal">CASTILLA – LA MANCHA</MenuItem>
              </Select>
            </>
            <br />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                <FormControl fullWidth margin="normal">
                  <Select
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                    }}
                    required
                  >
                    <MenuItem value="es">🇪🇸 (+34)</MenuItem>
                    <MenuItem value="us">🇺🇸 (+1)</MenuItem>
                    <MenuItem value="gb">🇬🇧 (+44)</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={9}>
                <Box width={"100%"}>
                  <br />
                  <PhoneInput
                    country={country}
                    value={phoneNumber}
                    disableDropdown={true}
                    disableCountryGuess={true}
                    onChange={setPhoneNumber}
                    enableLongNumbers={true}
                    inputStyle={{
                      width: "100%",
                      textAlign: "center",
                      fontSize: "16px",
                      height: "56px",
                      borderRadius: "4px",
                      border: "1px solid #ced4da",
                    }}
                    required
                  />
                </Box>
              </Grid>
            </Grid>
            <h3>
              Después de hacer clic para recibir la llamada DEMO, recibirá una
              llamada desde el siguiente número de teléfono:{" "}
              <b>+44 7414695890</b>
            </h3>
            <br />
            <Button
              className="callBtn"
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
            >
              <h2
                style={{
                  fontSize: "16px",
                }}
              >
                Haga clic aquí para recibir la llamada DEMO
              </h2>
              <div style={{ width: "20px" }} />
              <Call className="callIcon" />
            </Button>
          </form>
        </Container>
      </Grid>
    </div>
  );
};
